import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../shared/material.module';
import { CaAlertPanel } from './alert-panel/alert-panel';
import { CaButtonComponent } from './button/button';
import { CaDismissibleHint } from './dismissible-hint/dismissible-hint.component';
import { CaInputComponent } from './input/input.component';
import { CaLargeCard } from './large-card/large-card.component';
import { CaNarrowPage } from './narrow-page/narrow-page.component';
import { CaPasswordInputComponent } from './password-input/password-input.component';
import { CaPhoneNumberInputComponent } from './phone-number-input/phone-number-input.component';
import { CaSeparatorComponent } from './separator/separator.component';
import { CaVerificationInputComponent } from './verification-input/verification-input.component';
import { CaWidePage } from './wide-page/wide-page.component';
import { CaPageHeaderComponent } from './page-header/page-header.component';
import { CaInfoCardComponent } from './info-card/info-card.component';
import { CaFormFieldComponent } from './form-field/form-field.component';
import { CaHintComponent } from './hint/hint.component';
import { PasswordStrengthPipe } from './pipes/password-strength/password-strength.pipe';
import { CountryFlagPipe } from './pipes/country-flag.pipe';
import { CaStatusChipComponent } from './status-chip/status-chip.component';
import { CaMediumCardComponent } from './medium-card/medium-card.component';
import { ChipComponent } from './chip/chip.component';

export const components = [
  CaAlertPanel,
  CaButtonComponent,
  CaFormFieldComponent,
  CaHintComponent,
  CaInputComponent,
  CaInfoCardComponent,
  CaLargeCard,
  CaNarrowPage,
  CaPageHeaderComponent,
  CaSeparatorComponent,
  CaWidePage,
  CaPhoneNumberInputComponent,
  CaVerificationInputComponent,
  CaPasswordInputComponent,
  CaDismissibleHint,
  CaStatusChipComponent,
  CaMediumCardComponent,
];

export const standaloneComponents = [ChipComponent];

export const pipes = [CountryFlagPipe, PasswordStrengthPipe];

@NgModule({
  imports: [CommonModule, MaterialModule, ReactiveFormsModule, TranslateModule, ChipComponent],
  declarations: [...components, ...pipes],
  exports: [...components, ...pipes, ...standaloneComponents],
})
export class CaDesignModule {}
